import React from 'react';
import {Helmet} from "react-helmet";
import { assets } from '../../config/assetConfig';
import useStyles from './styles'

export default function ConfigurationErrorPage({ config, missingKeys}) {
  const classes = useStyles()
  return (
    <div style={{ fontFamily: config.FONT_FAMILY}} className={classes.configErrorContainer}>
      <Helmet>
        <meta
          name="description"
          content={config.BOT_NAME}
        />
        <title>Missing Config</title>
      </Helmet>
      <img src={assets.icon('error.svg')} alt="error_icon" className={classes.errorIcon} />
      <h2>Configuration keys missing</h2>
      <h5>The following keys are required in your local config file but do not exist, check against the sample file provided for the default values: </h5>
      {missingKeys.map((k, i) =>
        <div key={i}>
          <label>{k}</label> <br />
        </div>
      )}
    </div>
  )
}
